import React, { Component } from 'react';
import 'react-datetime/css/react-datetime.css';
import BasicSectionHeader from '../../../components/views/BasicSectionHeader';
import InputField from '../../../components/inputs/inputField.js';
import SelectField from '../../../components/inputs/selectField.js';
import ToggleField from '../../../components/inputs/toggleField.js';

const eventTypeOptions = [ { label: 'Public', value: true }, { label: 'Invite Only', value: false } ];

class EventAccess extends Component {
	constructor(props) {
		super(props);
		const event = props.event;
		this.state = {
			editing: false,
			editedEvent: event,
			uploadingBanner: false,
			copiedPassthrough: false,
			privatePathOptions: event.pathOptions.map((po) => {
				return { label: po.title, value: po.pathSlug };
			}),
			formFilled: false,
			requiredFields: {
				meetingPassword: false,
				SSOLoginUrl: false,
				registrationPageSlug: false
			}
		};
	}

	saveDetails = (e) => {
		const editedEvent = this.state.editedEvent;

		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedEvent[key] || editedEvent[key] === '') {
				if (key === 'meetingPassword' && !editedEvent.enableMeetingPassword) {
					return;
				} else if (key === 'SSOLoginUrl' && !editedEvent.enableSSOLogin) {
					return;
				} else if (key === 'registrationPageSlug' && !editedEvent.allowPublicRegistrations) {
					return;
				}
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		if (valid) {
			this.props.saveDetails({ ...this.props.event, ...editedEvent }, () => {
				this.setState({ editing: false, formFilled: false, error: '', requiredFields: requiredFields });
			});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	handleStartDateTimeChange = (date) => {
		this.setState(() => ({
			editedEvent: {
				...this.state.editedEvent,
				startDateTime: date._d
			}
		}));
	};

	handleEndDateTimeChange = (date) => {
		this.setState(() => ({
			editedEvent: {
				...this.state.editedEvent,
				endDateTime: date._d
			}
		}));
	};

	handleUploadHeader = () => {};

	cancelEdit = () => {
		const event = this.props.event;
		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});
		this.setState({
			editedEvent: event,
			editing: false,
			formFilled: false,
			requiredFields: requiredFields
		});
	};

	render() {
		const { editing, editedEvent, copiedPassthrough, formFilled, requiredFields } = this.state;
		const { event, sectionName, readOnly } = this.props;
		const registrationPagePath = this.state.privatePathOptions.find(
			(path) => path.value == editedEvent.registrationPageSlug
		);
		return (
			<div className="sectionContainer">
				<BasicSectionHeader
					editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveDetails}
					updatedAt={event.updatedAt}
					title={'Event Access'}
					description={'Set up how people can access your event.'}
					breadcrumbs={[
						{
							name: 'Events',
							link: `/admin/events`
						},
						{
							name: event.name,
							link: `/admin/events/${event._id}/0`
						}
					]}
				/>
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
						<SelectField
							label={'Event Type'}
							disabled={readOnly}
							name="eventType"
							options={eventTypeOptions}
							value={editedEvent.allowPublicRegistrations ? eventTypeOptions[0] : eventTypeOptions[1]}
							onChange={(eventType) => {
								this.setState({
									editedEvent: {
										...editedEvent,
										allowPublicRegistrations: eventType.value,
										requestAccessEnabled:
											eventType.value == true ? false : editedEvent.requestAccessEnabled,
										eventType: eventType.label
									},
									editing: true
								});
							}}
						/>
						{editedEvent.allowPublicRegistrations ? (
							<SelectField
								label={'Registration Page'}
								disabled={readOnly}
								name="registrationPageSlug"
								required={true}
								errorTrigger={requiredFields.registrationPageSlug}
								options={this.state.privatePathOptions}
								value={
									registrationPagePath ? (
										registrationPagePath
									) : (
										{
											label: '',
											value: ''
										}
									)
								}
								onChange={(path) => {
									this.setState({
										editedEvent: {
											...editedEvent,
											registrationPageSlug: path.value
										},
										editing: true
									});
								}}
							/>
						) : (
							<ToggleField
								label={'Enable Request Access'}
								onChange={() =>
									this.setState({
										editedEvent: {
											...editedEvent,
											requestAccessEnabled: !this.state.editedEvent.requestAccessEnabled
										},
										editing: true
									})}
								disabled={readOnly}
								icons={false}
								checked={editedEvent.requestAccessEnabled}
							/>
						)}
						{editedEvent.allowPublicRegistrations && (
							<ToggleField
								label={'Enable Registration Auto Login'}
								onChange={() =>
									this.setState({
										editedEvent: {
											...editedEvent,
											autoLoginFromRegistration: !this.state.editedEvent.autoLoginFromRegistration
										},
										editing: true
									})}
								disabled={readOnly}
								icons={false}
								checked={editedEvent.autoLoginFromRegistration}
							/>
						) }
						<ToggleField
							label={'Enable Meeting Password'}
							onChange={() =>
								this.setState({
									editedEvent: {
										...editedEvent,
										enableMeetingPassword: !this.state.editedEvent.enableMeetingPassword
									},
									editing: true
								})}
							disabled={readOnly}
							icons={false}
							checked={editedEvent.enableMeetingPassword}
						/>
						{editedEvent.enableMeetingPassword && (
							<InputField
								label={'Meeting Password'}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.meetingPassword}
								value={editedEvent.meetingPassword}
								onChange={(e) => {
									this.setState({
										editedEvent: { ...editedEvent, meetingPassword: e.target.value },
										editing: true
									});
								}}
							/>
						)}
						{this.props.ssoAvailable && (
							<div>
								<ToggleField
									label={'Enable SSO'}
									checked={editedEvent.enableSSOLogin}
									icons={false}
									disabled={readOnly}
									onChange={() =>
										this.setState({
											editedEvent: {
												...editedEvent,
												enableSSOLogin: !this.state.editedEvent.enableSSOLogin
											},
											editing: true
										})}
								/>

								{editedEvent.enableSSOLogin && (
									<InputField
										label={'SSO URL'}
										className={`editingField`}
										required={true}
										errorTrigger={requiredFields.SSOLoginUrl}
										disabled={readOnly}
										value={editedEvent.SSOLoginUrl}
										onChange={(e) => {
											this.setState({
												editedEvent: { ...editedEvent, SSOLoginUrl: e.target.value },
												editing: true
											});
										}}
									/>
								)}
							</div>
						)}

						<ToggleField
							label={'Enable Magic Link'}
							checked={editedEvent.enablePassthroughPassword}
							icons={false}
							disabled={readOnly}
							onChange={() =>
								this.setState({
									editedEvent: {
										...editedEvent,
										enablePassthroughPassword: !this.state.editedEvent.enablePassthroughPassword
									},
									editing: true
								})}
						/>
						{editedEvent.enablePassthroughPassword && (
							<div className="toggleField">
								<a href={event.passthroughLink} target="_blank" className="se-blue calibreRegular">
									{event.passthroughLink}
								</a>

								<div
									className="actionButton actionSave"
									style={{ minWidth: 80 }}
									onClick={async () => {
										navigator.clipboard.writeText(event.passthroughLink).then(
											() => {
												/* clipboard successfully set */
												this.setState({ copiedPassthrough: true });
												setTimeout(() => this.setState({ copiedPassthrough: false }), 1000);
											},
											() => {
												/* clipboard write failed */
												document.execCommand('copy', true, event.passthroughLink);
												this.setState({ copiedPassthrough: true });
												setTimeout(() => this.setState({ copiedPassthrough: false }), 1000);
											}
										);

										/* if ('clipboard' in navigator) {
												await navigator.clipboard.writeText(event.passthroughLink);
											} else {
												document.execCommand('copy', true, event.passthroughLink);
											} */
									}}
								>
									<div className="calibreBold fs-16">
										<i className="las la-copy" />
										{copiedPassthrough ? 'Copied!' : 'Copy'}
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
export default EventAccess;
